import { useErrorNotifier } from "components/instrumentation/source";
import { useExperiments } from "components/store/source/context/ExperimentsContext";

import { SUNSET_LOGIN_WITH_SONDER } from "types/experiments";

export const useSunsetLoginWithSonder = () => {
  const { getExperiment } = useExperiments();
  const errorNotifier = useErrorNotifier();

  try {
    const experiment = getExperiment(SUNSET_LOGIN_WITH_SONDER);
    if (!experiment) {
      return false;
    }
    return experiment?.value === "on";
  } catch (error) {
    errorNotifier.notify(
      error?.message ?? `Failed to get ${SUNSET_LOGIN_WITH_SONDER} experiment`,
    );
    return false;
  }
};
